import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-toolbar-menu-item',
  templateUrl: './toolbar-menu-item.component.html',
  styleUrls: ['./toolbar-menu-item.component.css']
})
export class ToolbarMenuItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-menu-item/toolbar-menu-item.component.ts